<style scoped>
.this__mobile-icon {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: white;
}
.this__mobile-icon--active {
  color: #72ef8d;
}
.this__item {
  width: 80px;
  text-align: center;
}
</style>

<template>
  <div class="demo__FooterMobileMenu demo__flex demo__flex-space-around">
    <div
      class="this__item demo__flex demo__flex-column demo__text-center demo__flex-middle"
      @click="$router.push('/')"
    >
      <i
        class="this__mobile-icon fa-light fa-house"
        v-bind:class="{
          'this__mobile-icon--active': $route.path === '/',
        }"
      ></i>
      <div
        class="demo__font--11 demo__weight--400 demo__color--white demo__margin-top--4"
      >
        {{ $t("Home") }}
      </div>
    </div>

    <div
      v-for="modul in _modules"
      :key="modul.id"
      class="this__item demo__flex demo__flex-column demo__text-center demo__flex-middle"
      @click="
        $router.push(
          '/' + modul.id + (modul.id === 'community' ? '/cases' : '/services')
        )
      "
    >
      <i
        class="this__mobile-icon fa-light"
        v-bind:class="{
          [modul.mobileIcon]: true,
          'this__mobile-icon--active': $route.path.indexOf(modul.id) !== -1,
        }"
      >
      </i>
      <div
        class="demo__font--11 demo__weight--400 demo__color--white demo__margin-top--4"
      >
        {{ $t(modul.id) }}
      </div>
    </div>
    <div
      class="this__item demo__flex demo__flex-column demo__text-center demo__flex-middle"
    >
      <div v-if="user" @click="$router.push('/lk')">
        <i
          class="this__mobile-icon fa-light fa-user"
          v-bind:class="{
            'this__mobile-icon--active': $route.path.indexOf('lk') !== -1,
          }"
        ></i>
        <div
          class="demo__font--11 demo__weight--400 demo__color--white demo__margin-top--4"
        >
          {{ $t("Profile") }}
        </div>
      </div>
      <AuthLockBlock
        v-else
        class="this__item demo__flex demo__flex-column demo__text-center demo__flex-middle"
      >
        <i class="this__mobile-icon fa-light fa-user"> </i>
        <div
          class="demo__font--11 demo__weight--400 demo__color--white demo__margin-top--4"
        >
          {{ $t("Submit") }}
        </div>
      </AuthLockBlock>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["modules", "user"]),
    _modules() {
      return this.modules.filter((module) => {
        return !module.hide;
      });
    },
  },
  methods: {
    logoutUser() {
      this.$store.dispatch("logoutUser");
      this.$root.$emit("stopUserUpdate");
    },
  },
};
</script>
